module.exports = __webpack_public_path__ + "static/media/report-diary-icon.7d96918b.svg";